// Возможные цели сравнения психопрофилей (коды совпадают с backend/AI).
export interface ComparisonPurpose {
  code: string;
  label: string;
}

export const COMPARISON_PURPOSES: ComparisonPurpose[] = [
  { code: 'romantic_couple_candidates', label: 'Оценка кандидатов на семейную пару' },
  { code: 'existing_couple', label: 'Анализ действующей пары' },
  { code: 'parent_child_mother', label: 'Мать и ребёнок' },
  { code: 'parent_child_father', label: 'Отец и ребёнок' },
  { code: 'guardian_child', label: 'Опекун и ребёнок' },
  { code: 'siblings', label: 'Сиблинги (братья/сёстры)' },
  { code: 'co_parenting', label: 'Совместное воспитание (разведённые родители)' },
  { code: 'family_business', label: 'Семейный бизнес' },
  { code: 'work_colleagues', label: 'Коллеги' },
  { code: 'leader_subordinate', label: 'Руководитель и подчинённый' },
  { code: 'business_partners', label: 'Бизнес-партнёры' },
  { code: 'team_formation', label: 'Формирование команды/бригады/смены' },
  { code: 'hr_candidate_team', label: 'Кандидат и команда/руководитель' },
  { code: 'project_team', label: 'Проектная группа' },
  { code: 'shift_work_crew', label: 'Вахтовая/сменная бригада' },
  { code: 'sports_team', label: 'Спортивная команда' },
  { code: 'military_unit', label: 'Воинское подразделение' },
  { code: 'expedition_crew', label: 'Экспедиционный состав' },
  { code: 'teacher_student', label: 'Педагог и учащийся' },
  { code: 'mentor_mentee', label: 'Наставник и подопечный' },
  { code: 'educational_group', label: 'Учебная группа' },
  { code: 'therapist_client', label: 'Терапевт и клиент (терапевтический альянс)' },
  { code: 'group_therapy_pair', label: 'Подбор пар для групповой терапии' },
  { code: 'rehabilitation_group', label: 'Реабилитационная группа' },
  { code: 'conflict_prevention', label: 'Прогноз и профилактика конфликтов' },
  { code: 'communication_style_recommendation', label: 'Рекомендации по стилю общения' },
  { code: 'therapy_modality_selection', label: 'Выбор типа психотерапии/психокоррекции' },
  { code: 'roommate_compatibility', label: 'Соседи по общежитию/совместному проживанию' },
  { code: 'crisis_interaction', label: 'Взаимодействие в кризисных условиях' },
  { code: 'creative_tandem', label: 'Творческий тандем' },
  { code: 'volunteer_group', label: 'Волонтёрская группа' },
  { code: 'social_worker_client', label: 'Социальный работник и клиент' },
  { code: 'mediation', label: 'Медиация сторон' },
  { code: 'negotiation_partners', label: 'Партнёры по переговорам' },
  { code: 'elderly_care', label: 'Уход за пожилым (сиделка–подопечный)' },
  { code: 'general_compatibility', label: 'Общее сравнение совместимости' },
];

export function comparisonPurposeLabel(code: string | null | undefined): string {
  if (!code) return '';
  return COMPARISON_PURPOSES.find((p) => p.code === code)?.label ?? code;
}